import router from "../axios";
import config from "../../config/index"
const { baseUrl } = config;

function getInventoryList(data) {
  // 获取盘点列表
  return router({
    url: baseUrl + "asset/discovery/v1/getFixedAssetDiscoveryBatchList",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

function getStoreList(data) {
  // 获取当前门店所有下级门店
  return router({
    url: baseUrl + "store/v1/switchPage",
    data: data,
    method: "POST",
  });
}

// 发起盘点
function startInventory(data) {
  return router({
    url: baseUrl + "asset/discovery/v1/start",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

//  获取所有价签尺寸类型
function getAllTagType(data) {
  return router({
    url: baseUrl + "/tag/v1/getAllTagType",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}



// 价签盘点完成
function completeInventory(data) {
  return router({
    url: baseUrl + "asset/discovery/v1/complete",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}


// 单个门店价签盘点  价签明细列表
function inventoryDetailList(data) {
  return router({
    url: baseUrl + "asset/discovery/v1/getFixedAssetDiscoveryLogList",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}




// 获取单批次盘点  关闭盘点时   门店信息明细  &&  盘点报告列表
function inventoryInfoList(data) {
  return router({
    url: baseUrl + "asset/discovery/v1/getFixedAssetDiscoveryList",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}



// 价签盘点汇总 数据
function inventorySummary(data) {
  return router({
    url: baseUrl + "asset/discovery/v1/summary",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 导出汇总
function exportSummary(data) {
  return router({
    url: baseUrl + "asset/discovery/v1/export/summary",
    data: data,
    method: "POST",
    responseType: 'blob',
    // header: {
    //   'Content-Type': 'application/json'
    // }
  });
}

// 导出
function exportItem(data) {
  return router({
    url: baseUrl + "asset/discovery/v1/export/store/details",
    data: data,
    responseType: 'blob',
    method: "POST",
  });
}

export {
  getInventoryList,
  getStoreList,
  startInventory,
  getAllTagType,
  inventorySummary,
  completeInventory,
  inventoryInfoList,
  exportSummary,
  exportItem,
  inventoryDetailList
}